import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-blackout-dates',
  templateUrl: './blackout-dates.component.html',
  styleUrls: ['./blackout-dates.component.scss'],
  standalone: false,
})
export class BlackoutDatesComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() showExpansionGuide: string;
  @Input() accordionActiveSection: string[];
  @Output() onOpenExpansionEmit = new EventEmitter<string>();
  @Output() onCloseExpansionEmit = new EventEmitter<void>();
  @Output() onExpandedNeededEmit = new EventEmitter<string>();
  todayDate = new Date();
  maximumDate = new Date('01/01/2031');
  startDate: string;
  endDate: string;
  blackoutDaysNote: string;
  showCustomBlackoutDateErrorMsg: string;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {}

  addBlackoutDate() {
    const datePickerValidation = this.datePickerValidationDates();
    if (datePickerValidation) {
      this.showCustomBlackoutDateErrorMsg = `Please select a dates within the next 10 years`;
      return;
    }

    if (!this.startDate || !this.endDate) {
      this.showCustomBlackoutDateErrorMsg = 'Select a valid date range to save it';
      return;
    }

    if (this.blackoutDaysField?.length > 10) {
      this.showCustomBlackoutDateErrorMsg = 'Please, set blackout dates up to 10';
      return;
    }

    const index = this.blackoutDaysField.length;
    const addBlackoutDateLine = this.formBuilder.group({
      index: [index],
      startDate: [this.startDate],
      endDate: [this.endDate],
      note: [this.blackoutDaysNote],
    });

    this.blackoutDaysField.push(addBlackoutDateLine);
    this.resetBlackoutDaysFields();
  }

  resetBlackoutDaysFields(): void {
    this.startDate = undefined;
    this.endDate = undefined;
    this.blackoutDaysNote = undefined;
    this.showCustomBlackoutDateErrorMsg = undefined;
  }

  removeBlackoutDate(index: number): void {
    if (this.blackoutDaysField?.length >= 0) {
      this.blackoutDaysField.removeAt(index);
    }
  }

  get blackoutDaysField(): UntypedFormArray {
    return this.formGroup.get('customBlackoutDates') as UntypedFormArray;
  }
  handleDateRangeChange(event) {
    const { end, start } = event;
    this.startDate = start;
    this.endDate = end;
  }
  datePickerValidationDates(): boolean {
    return (
      new Date(this.startDate) > this.maximumDate ||
      new Date(this.endDate) > this.maximumDate ||
      new Date(this.endDate) < this.todayDate ||
      new Date(this.endDate) < this.todayDate
    );
  }

  onOpenExpansion(section: string): boolean {
    this.onOpenExpansionEmit.emit(section);
    return true;
  }

  onCloseExpansion(): void {
    this.onCloseExpansionEmit.emit();
  }

  isExpandedNeeded(section: string): boolean {
    return this.accordionActiveSection.some((value) => value == section);
  }
}
